import { Controller } from "stimulus"

// Live preview for image upload forms: shows the selected file before submitting.
export default class extends Controller {
  static targets = ["input", "preview", "placeholder", "filename"]

  preview() {
    const file = this.inputTarget.files[0]
    if (!file) return

    if (this.hasFilenameTarget) this.filenameTarget.textContent = file.name

    const reader = new FileReader()
    reader.onload = (event) => {
      this.previewTarget.src = event.target.result
      this.previewTarget.classList.remove("d-none")
      if (this.hasPlaceholderTarget) this.placeholderTarget.classList.add("d-none")
    }
    reader.readAsDataURL(file)
  }
}
